import { render, staticRenderFns } from "./image.vue?vue&type=template&id=0df85783&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&id=0df85783&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df85783",
  null
  
)

export default component.exports